import { useMutation } from '@tanstack/react-query'
import { useApi } from 'api'

const useDeleteInvoice = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void
  onError?: () => void
}) => {
  const client = useApi()

  const { mutate: deleteInvoice, isPending } = useMutation({
    mutationFn: async (id: number) => {
      const response = await client.deleteInvoice(id)
      return response
    },
    onSuccess,
    onError,
  })

  return { deleteInvoice, isPending }
}

export default useDeleteInvoice
